import { taggingButtonTypes } from "@/utils/taggingUtils";
import iconLibrary from "./iconLibrary";
import {
  BLOQUEOS_A_MOVILES,
  CHANGE_LANDLINE,
  MULTI_CALL_LANDLINE,
  LOST_CALL_LANDLINE,
  CALL_REJECTION_LANDLINE,
  WAITING_LANDLINE,
  IDENTITI_CALL_LANDLINE,
  TRASLADE_LINE_LANDLINE,
  BASIC_PACK_LANDLINE,
  SERVICE_MAINTENANCE_LANDLINE,
  CALL_RESPONSE_LANDLINE,
  INMEDIATE_DETOUR_LANDLINE,
  COMUNICATE_DETOUR_LANDLINE,
  NOT_RESPONSE_DETOUR_LANDLINE,
  TERMINAL_PACK,
  IDENTITI_CALL_LANDLINE_RADIO,
  CALL_RESPONSE_LANDLINE_RADIO,
  WAITING_LANDLINE_RADIO,
  INMEDIATE_DETOUR_LANDLINE_RADIO,
  COMUNICATE_DETOUR_LANDLINE_RADIO,
  NOT_RESPONSE_DETOUR_LANDLINE_RADIO,
  DIVERSION_DO_NOT_DISTURB,
  MULTI_CALL_LANDLINE_RADIO,
} from "@/constants/general-managment-constants";

export const idFront = "TC";
export const enviromentKey = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const DEV = "development";
export const PROD = "production";
export const DATA_NEEDED_EDGE = 0.8;
export const USER_TYPE = {
  TELCO: "Telco",
  NO_CLIENTS: "",
  GESTOR: "Gestor",
};

/* SCOPE */
export const TITULAR = 0;
export const LIGHT = 1;
export const ANONIMO = 2;
export const CATALOG_SECTIONS = {
  VERTICALS: {
    ID: "387",
    SUB_SECTIONS: {
      // COMMUNICATIONS: "388",
      SECURITY: "389",
      HEALTH: "390",
      FINANCES: "391",
      GAMING: "544",
    },
  },
};
export const ARRAY_SUBSECCION = [
  // CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.HEALTH,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.FINANCES,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.GAMING,
];

export const defaultTrackingPageNumber = 1;

/* PRODUCT TYPES */
export const FUSION = 0; /* Internet fijo televisión y movil */
export const TRIO = 1; /* Internet, fijo y televisión */
export const DUO = 2; /* Internet y fijo */
export const ONLY_MOBILE = 3;
export const ONLY_PHONE = 4;
export const MOBILE_PREPAID = 5;
export const OTHERS = 9;
export const EQUIPAMIENTO = 9;
export const HEALTH = 9;
export const GAME_PASS = 11;

/* TYPES */
export const PREPAID = "prepaid";

/* PREPAID TARIFFS */
export const PREPAID_TARIFFS = {
  HABLA_6: 'H6',
}

export const NETFLIX_PRODUCT_OFFERING = "496";
export const NETFLIX_PRODUCT_OFFERING_NEW = "498";
export const NETFLIX_TEXTS = {
  X2: "X2",
  X4: "X4",
};
export const TRIO_TEXTS = {
  AND_TV: "y TV",
  TV: "| TV",
};

export const SALUTE = {
  EVENING: "Buenas tardes",
  MORNING: "Buenos días",
  NIGHT: "Buenas noches",
};

export const BASIC_STEPPER_DATA = {
  TOTAL_STEPS: 10,
  PERSONAL_DATA: 1,
  CHOOSE_ADDRESS: 2,
  INTRODUCE_ADDRESS: 3,
  CHOOSE_LAND_LINE: 4,
  CHOOSE_MOBILE_LINE: 5,
  FINANCIAL_DATA: 6,
  CONFIGURE_ADDONS: 7,
  CONFIGURATION: 8,
  SUMMARY_R2R: 9,
  CHOOSE_MOBILE_LINE_OTP: 10,
  FIRM: 11,
  SUMMARY: 11,
};

/* PRODUCTOFFERING CATEGORIES */
export const PO_CATEGORY_TELEVISION = 51; /* De momento solo para Movistar Plus Lite */
export const FTTR_PO_CATEGORY = 83; /* Fibra invisible FTTR */

/* STATE TRACKING ORDER */
export const RECEIVED_TRACKING_ORDER = 1;
export const IN_PROGRESS_TRACKING_ORDER = 2;
export const INCIDENCE_TRACKING_ORDER = 3;
export const FINISHED_TRACKING_ORDER = 4;
export const CANCELED_TRACKING_ORDER = 5;
export const IN_PREPARATION_TRACKING_ORDER = 6;
export const PROGRAMMED_TRACKING_ORDER = 7;

/* STATE TYPE ORDER */
export const SHUTTLE_TRACKING_ORDER = "44";

/* FILTER TYPE ORDER */
export const DISNEY_CREDENTIAL_TRACKING_ORDER = "disney";

export const CHANGE_ICC = "cambio de icc";
export const MANAGE_ESIM = "Gestionar eSIM";
export const MANAGE_ESIM_LINK =
  "https://www.movistar.es/area-cliente/gestiones/linea-movil/e-sim/inicio-proceso";

export const CALENDAR_LOCAL_ES = {
  // months list by order
  months: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],

  // week days by order
  weekDays: [
    {
      name: "Lunes",
      short: "L",
    },
    {
      name: "Martes",
      short: "M",
    },
    {
      name: "Miércoles",
      short: "X",
    },
    {
      name: "Jueves",
      short: "J",
    },
    {
      name: "Viernes",
      short: "V",
    },
    {
      name: "Sábado",
      short: "S",
      isWeekend: true,
    },
    {
      name: "Domingo", // used for accessibility
      short: "D", // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 6,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  defaultPlaceholder: "Select...",

  // for input range value
  from: "from",
  to: "to",

  // used for input value when multi dates are selected
  digitSeparator: ",",

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,

  monthNames: [
    "ENE",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DIC",
  ],
};

export const allKindProduct = {
  phone: "phone",
  mobile: "mobile",
  internet: "internet",
  tv: "tv",
};

export const ItemFloatKind = {
  SHIPPING: "SHIPPING",
  TELCOOUT: "TELCOOUT",
  NO_NOTIFICATIONS: "NO_NOTIFICATIONS",
  UPGRADE1GB: "UPGRADE1GB",
  UPGRADE300MB: "UPGRADE300MB",
  MOBILERENT2RENT: "MOBILERENT2RENT",
  DEBTPAYMENT: "DEBTPAYMENT",
};

export const nookInfoExchangeIds = {
  HeaderNotifications: "HeaderNotifications",
  Notifications: "notifications",
};

export const usageDetailsText = {
  extraExpensesPill: "€ Consumo extra",
  usageClosure: "",
  usageDetailsLabel: "Detalles de consumo",
  usageDetailsPrev: "Mis productos",
};
export const urlToWhatsapp = "https://wa.me/34638101004";
/* INTERNET DEVICES */
export const HGU = "HGU";

export const LINK_LEGAL_CONDITION_FSP =
  "http://www.movistar.es/estaticos/pdfs/factura-sin-papel/Condiciones-generales-del-servicio-FSP.pdf?";

export const handlingCodes = {
  NOTHINGTODO: 0, //  0: no hace nada
  FATAL: -2, // -2: error fatal
  UPGRADE: -4, // -4: Upgrade
  LOGIN: -5, // -5: Login
  MAINTENANCE: -6, // -6: Tapón mantenimiento
  REDIRECT_TO_LOGIN: -7, // -7: mandamos al login
};

export const serverErrorText = {
  errorAlt1: "error",
  errorTitle1:
    "Estamos trabajando para ofrecerte la información que has solicitado",
  errorAlt2: "error",
  errorMessage2: "Por favor, inténtalo de nuevo más tarde",
  errorTitle2: "No podemos mostrarte la información en este momento",
  errorMessage3:
    "Si eres titular, cierra sesión y  vuelve a entrar con contraseña",
  errorAlt3: "Solo titular",
  errorLabelButton3: "Cerrar sesión",
  errorLink3: "/misDatos",
  errorTitle3: "Información solo disponible para el titular de la línea",
  errorMessageNoUsages:
    "Cuando tengas consumos te mostraremos aquí el detalle para que puedas consultarlo",
  errorTitleNoUsages: "No has realizado ningún consumo",
  errorAltNoUsages: "No hay consumo",
  errorMessageNoTracking:
    "Cuando tengas algún pedido te mostraremos aquí el detalle para que puedas consultarlo",
  errorTitleNoTracking: "Si haces algún pedido podrás verlo aquí.",
  errorAltNoTracking: "No hay pedidos",
  errorMessageNoMovement:
    "Cuando tengas movimientos te mostraremos aquí el listado para que puedas consultarlo",
  errorTitleNoMovement: "No has realizado ningún movimiento",
  errorAltNoMovement: "No hay movimiento",
  errorExtraExpensesTitle: "No tienes consumos de este tipo en este periodo",
  errorExtraExpensesSubtitle:
    "Aquí verás el detalle de gastos extra durante el ciclo de facturación",
  errorConsultDate: "No se puede consultar tu cita en este momento",
};
export const alertUcrania = {
  label: "Movistar con Ucrania",
  info: "Desde el 24 de febrero y hasta nuevo aviso no se cobrarán las llamadas y SMS a Ucrania, ni el roaming.<br>Puedes ver consumos con su importe habitual, pero no aparecerán en las facturas.",
};

export const PPU_INDEX = -1;
export const UNLIMITED = -2;

export const titleDebtPaymentAlert = "Tienes facturas pendientes.";
export const subTitleDebtPaymentAlert =
  "Consulta el detalle para ver el importe.";
export const titleDebtPaymentAlertNegative =
  "Tienes una devolución a tu favor.";
export const subTitleDebtPaymentAlertNegative =
  "El reembolso del importe a tu favor está en proceso.";

export const toolTipDataRoaming =
  "Tu tarifa de datos incluye 50 GB/mes en<br>roaming en zona 1 (Unión Europea, Islandia,<br>Liechtenstein, Noruega y Reino Unido). Te<br>avisaremos vía SMS cuando estés a punto de<br>agotarlos. Si los superas, el uso de los datos<br>tendrá coste.";

export const yourPlanTitle = "TU PLAN";
export const productIncludedIn = "Producto incluido en";
export const interestingUrlsTitle = "ENLACES DE INTERÉS";
export const additionalDevices = "DISPOSITIVO ADICIONAL";
export const changeMyTariff = "Cambiar mi tarifa";
export const upgradeMyTariff = "Mejorar tarifa";
export const mobileTariffUrl =
  "https://www.movistar.es/particulares/movil/tarifas-moviles?pid=areaprivadatelco";

export const CUSTOMER_PRODUCT_TEMPLATES = {
  FULL: "full",
  MEDIUM: "medium",
  REDUCED: "reduced",
  SIMPLE: "simple",
};

export const URL_DEEPLINK_WALLET_NT_CERTI =
  "https://cert1-es.novum.team/_/account/core/webviews/v1.php/?id=nt-home&w=internal&p=flow";
export const URL_DEEPLINK_WALLET_NT =
  "https://appweb.movistar.es/_/account/core/webviews/v1.php/?id=nt-home&w=internal&p=flow";

export const CURRENCY = "€";

export const maintenanceStopperTexts = {
  errorTitle: "Tareas de mantenimiento",
  errorSubtitle:
    "Estamos haciendo tareas de matenimiento, volvemos lo antes posible",
  errorAlt: "Mantenimiento",
  errorLabelButton: "Ayúdanos a mejorar",
};

export const frontErrorText = {
  errorAlt: "Error",
  errorMessage: "No podemos mostrarte la información en este momento",
  errorTitle: "No podemos mostrarte la información en este momento",
  errorSubtitle: "Por favor, inténtalo de nuevo más tarde.",
  internetError:
    "Pronto podrás ver aquí toda la información de tu conexión a internet",
  internetAlt: "Internet",
  tvError: "Pronto podrás ver aquí toda la información de tu TV",
  tvAlt: "TV",
};
export const billClaimText = {
  noBills: "No tienes ninguna factura reclamada en el último año.",
  searchInputPlaceholder: "Introduce el identificador de factura o reclamación",
  searchInputPlaceholderMobile: "Id de factura o reclamación",
  dropdownText: "Factura reclamada",
  dropdownTextMobile: "Fact. reclamada",
  searchById: "Identificador",
  searchByDate: "Fecha",
  initDate: "Fecha de inicio",
  endDate: "Fecha de fin",
  searchButtonText: "Buscar",
  genericIdSearchError:
    "No hemos encontrado ningún resultado. Sólo puedes buscar las facturas y reclamaciones del último año.",
  genericDateSearchError:
    "No tienes ninguna factura reclamada entre las fechas seleccionadas.",
  moreThanYearDateError:
    "Solo podemos mostrarte las facturas y reclamaciones del último año. Si lo necesitas, contáctanos en el 1004 o acude a una tienda Movistar.",
  orderByDate: "Ordenar por fecha",
  orderByPrice: "Ordenar por precio",
  preTitleText: "",
  priceTitle: "Importe",
  phaseOpen: "En curso",
  phaseAnnulled: "Anulada",
  phaseClosed: "Finalizada",
  initText: "Inicio",
  endText: "Fin",
  statusOpen: "Abierto",
  statusOngoing: "En curso",
  statusResolution: "En resolución",
  statusEnded: "Finalizada",
  statusAnnulled: "Anulado",
  statusCanceled: "Anulada",
  // claimPrice: 'Importe reclamado',
  claimPrice: "Resolución",
  claimPricePending: "En análisis",
  claimPriceAccepted: "Favorable",
  claimPriceRejected: "Desfavorable",
  // returnPrice: 'Importe a devolver',
  returnPrice: "Importe a tu favor",
  returnPriceMobile: "Imp. a tu favor",
  taxText: "Impuestos no incl.",
  onlyThirdInfo:
    "La devolución del importe correspondiente se hará en una de tus próximas facturas.",
  thirdInfo:
    "La devolución tiene un importe adicional a tu favor que recibirás en una de tus próximas facturas.",
  detailText: "Ver detalle",
  notifyText: "Ver notificaciones",
  watchBill: "Ver factura",
  openNewClaim: "Abrir nueva reclamación",
  restoreSearch: "Ver todas",
  modalDescriptionGlobal:
    "La devolución del importe correspondiente a los conceptos reclamados se realizará de forma conjunta en una de tus próximas facturas.",
  infoBillsNormal: "reclamada",
  infoBillsFinded: "encontrada",
};
export const billClaimDetailText = {
  title: "Reclamación",
  tableColumn1: "Concepto reclamado",
  tableColumn2: "Resolución",
  tableColumn3: "Importe reclamado*",
  tableColumn4: "Importe a devolver*",
  taxExcluded: "*Impuestos no incluidos",
  preTitleText: "Reclamación ",
  phaseOpen: "En curso",
  phaseClosed: "Finalizada",
  initText: "Inicio",
  endText: "Fin",
  claimPrice: "Importe total reclamado",
  returnPrice: "Importe total a devolver",
  taxText: "Impuestos no incluidos",
  infoOpened:
    "Tu reclamación se resolverá en menos de un mes desde la fecha de inicio.",
  infoPaymentMethod: "Forma de pago",
  detailPaymentMethod: "Devolución en cuenta",
  billsClaimed: "Facturas reclamadas",
  billClaimed: "Factura reclamada",
  shortClaimPrice: "Importe reclamado",
  shortReturnPrice: "Importe a devolver",
  newBill: "Factura rectificativa",
  pending: "Pendiente",
  paymentThirdPartyDesc:
    "La devolución del importe correspondiente se realizará en una de tus próximas facturas.",
  paymentThirdPartyDescAlso:
    "Además, la devolución tiene un importe adicional a tu favor que podrás consultar en una de tus próximas facturas.",
  modalDescription:
    "La devolución del importe correspondiente a este concepto se realizará en una de tus próximas facturas.",
  modalDescriptionGlobal:
    "La devolución del importe correspondiente a los conceptos reclamados se realizará de forma conjunta en una de tus próximas facturas.",
};

/* FAKES PROPS */
export const fakeSettings = {
  speed: 2,
  primarycolor: "#F3F3F3",
  secondarycolor: "#ECEBEB",
};

export const providers = {
  dazn: "dazn",
  max: "max",
  disney: "disney",
  disneyCompativility: "disneyCompativility",
  disneyActivated: "disneyActivated",
  netflix: "netflix",
  skyshowtime: "skyshowtime"
};

export const EMAILMPLUS_FAKE_REGEX = /(^[0-9]+)@telefonica\.net/;
/* Opacity div (flyout) */
export const ANIMATION_FLYOUT_IN_1 = "opacityLayout";
export const ANIMATION_FLYOUT_OUT_1 = "opacityOff";
/* container div (flyout) */
export const ANIMATION_FLYOUT_IN_2 = "flyIn";
export const ANIMATION_FLYOUT_OUT_2 = "flyMeToTheMoon";

export const logoDisneyBlue =
  "https://www.movistar.es/estaticos/imagenes/svg/logo-disney-plus-blue.svg";

export const urlActivationDisneySat =
  "https://sitioseguro.movistarplus.es/disney";

export const ISOLATED = "ISOLATED";
export const THIRD_PARTIES_ID_LIST = {
  netflix: 1,
  nubico: 2,
  conexionSegura: 3,
  identificadorDeLlamasFijo: 8,
  eHealth: 9,
};

export const THIRDPARTIES_LIBRARY = {
  netflix: {
    serviceId: 1,
    serviceName: "Netflix",
  },
  nubico: {
    serviceId: 2,
    serviceName: "Nubico",
  },
  conexionSegura: {
    serviceId: 3,
    serviceName: "Conexión segura",
  },
  movistarCloud: {
    serviceId: 4,
    serviceName: "Movistar Cloud",
  },
  movistarCar: {
    serviceId: 5,
    serviceName: "Movistar Car",
  },
  soteira: {
    serviceId: 6,
    serviceName: "Movistar Prosegur Alarmas",
  },
  qustodio: {
    serviceId: 7,
    serviceName: "Qustodio Premium",
  },
  identificadorDeLlamasFijo: {
    serviceId: 8,
    serviceName: "Identificacin de Llamadas Fijo",
  },
  eHealth: {
    serviceId: 9,
    serviceName: "Movistar Salud",
  },
};

export const RECOMMENDED_THIRDSERVICE = [
  // conexion segura
  {
    service: { ...THIRDPARTIES_LIBRARY.conexionSegura },
    /* "kindProduct: 'internet'," esto implica que colgara de internet dentro del bundle,
    OJO si se añade un hastag a productTypes[ ONLY_MOBILE ],
    este no funcionará ya que un hastag no tiene internet */
    kindProduct: "internet",
    productTypes: [FUSION, TRIO, DUO],
  },
  {
    service: { ...THIRDPARTIES_LIBRARY.conexionSegura },
    kindProduct: "mobile",
    productTypes: [ONLY_MOBILE],
  },
  {
    service: { ...THIRDPARTIES_LIBRARY.eHealth },
    kindProduct: "",
    productTypes: [HEALTH],
  },
  // if kindProduct = ''  means no dependencies
  /* para recomendar más cosas añadir a continuación como estos ejemplos

  {
    service: { ...THIRDPARTIES_LIBRARY.movistarCar },
    kindProduct: 'internet',
    productTypes: [FUSION, TRIO, DUO],
  },
  {
    service: { ...THIRDPARTIES_LIBRARY.conexionSegura },
    kindProduct: 'phone',
    productTypes: [FUSION, TRIO, DUO],
  },
  {
    service: { ...THIRDPARTIES_LIBRARY.netflix },
    kindProduct: 'tv',
    productTypes: [FUSION, TRIO, DUO],
  },
  */
];

export const INVISIBLE_CHILD_PACKAGE = "NINJA";

export const dependenciesList = {
  misProductos: {
    fn: "getMyProductsData",
    file: "product",
  },
  initializeUser: {
    fn: "initializeUser",
    file: "user",
  },
  activateLines: {
    fn: "getActivateLineData",
    file: "product",
  },
  getMyData: {
    fn: "getClientData",
    file: "client",
  },
  upgradeLinesData: {
    fn: "getUpgradesLinesData",
    file: "product",
  },
  getMyUsages: {
    fn: "getMyUsages",
    file: "usages",
  },
  getAllAccumulatedUsages: {
    fn: "getAllAccumulatedUsagesData",
    file: "usages",
  },
  getDebtPaymentData: {
    fn: "getDebtPaymentData",
    file: "client",
  },
  getBonusByProductId: {
    fn: "getBonusByProductId",
    file: "bonus",
  },
  getClientTvInfo: {
    fn: "getClientTvInfo",
    file: "tv",
  },
  getProviderCompatibility: {
    fn: "getProviderCompatibility",
    file: "thirdParties",
  },
  getNewProviderCompatibility: {
    fn: "getNewProviderCompatibility",
    file: "thirdParties",
  },
  getProviderStatus: {
    fn: "getProviderStatus",
    file: "thirdParties",
  },
  getNewProviderStatus: {
    fn: "getNewProviderStatus",
    file: "thirdParties",
  },
  getCompatibilityDisneyData: {
    fn: "getCompatibilityDisneyData",
    file: "thirdParties",
  },
  // BILLS
  getMyBills: {
    fn: "getMyBills",
    file: "bills",
  },
  getMyBillsClaims: {
    fn: "getBillsClaimsData",
    file: "bills",
  },
  ecoBill: {
    fn: "postEcoBill",
    file: "bills",
  },
  // MISCELLANY
  getInfoContest: {
    fn: "getInfoContest",
    file: "miscellany",
  },
  // BREAKDONW
  getBreakdownReasonsData: {
    fn: "getBreakdownReasonsData",
    file: "breakdown",
  },
  getBreakdownTracking: {
    fn: "getBreakdownTracking",
    file: "breakdown",
  },
  // SELFDIAGNOSIS
  getReason: {
    fn: "getReason",
    file: "selfDiagnosis",
  },
  // PREPAID
  getAccumulatedUsagesPrepaid: {
    fn: "getAccumulatedUsagesPrepaid",
    file: "prepaid",
  },
  getBalancePrepaid: {
    fn: "getBalancePrepaid",
    file: "prepaid/index",
  },
  getDetailsUsagesPrepaid: {
    fn: "getDetailsUsagesPrepaid",
    file: "prepaid",
  },
  getListMovementPrepaid: {
    fn: "getListMovementPrepaid",
    file: "prepaid/index",
  },
  // TOKENIZACIÓN
  getUserTokens: {
    fn: "getUserTokens",
    file: "tokenization",
  },
  getCatalogueOffers: {
    fn: "getCatalogue",
    file: "tokenization",
  },
  getBonusPrepaidById: {
    fn: "getBonusPrepaidById",
    file: "prepaid",
  },
  getListTariff: {
    fn: "getListTariff",
    file: "prepaid",
  },
  getSpecificBonusPrepaidById: {
    fn: "getSpecificBonusPrepaidById",
    file: "prepaid",
  },
  createOneClickCQ: {
    fn: "createOneClickCQ",
    file: "oneClick",
  },
  //Orion
  orionInfo: {
    fn: "getOrionInfoData",
    file: "orion",
  },
  //Orion LIST
  orionInfoList: {
    fn: "getOrionInfoData",
    file: "orion",
  },
  //GeneralManagments
  generalManagamentInfo: {
    fn: "getGeneralManagmentData",
    file: "general-managment",
  },
  //cq
  sellTypes: {
    fn: "getSellTypes",
    file: "cq",
  },
  //tracking
  getListTracking: {
    fn: "getListTracking",
    file: "tracking/index",
  },
  getDetailTracking: {
    fn: "getDetailTracking",
    file: "tracking/index",
  },
  getOrderDetails: {
    fn: "getOrderDetails",
    file: "tracking/index",
  },
  activateLines: {
    fn: "getActivateLineData",
    file: "product",
  },
  getTvPackagesInfo: {
    fn: "getTvPackagesInfo",
    file: "tv",
  },
  getEsimStatus: {
    fn: "getEsimStatus",
    file: "product",
  },
  getEsimDownload: {
    fn: "getEsimDownload",
    file: "product",
  },
  //consents
  getClientConsents: {
    fn: "getClientConsents",
    file: "consents",
  }
};

export const fusionDevicesFilter = {
  id: "dispositivosFusion",
  isSelected: true,
  listTitleName: "Filtrar por:",
  text: "Dispositivos Fusión",
};

/* CONTRACTS */
export const PERMANENCE = "POC";
export const GUARANTEE = "POG";
export const SALE_TERM = "POST";
export const withCommitmentTermPrefix = "Permanencia hasta el: ";
export const withoutCommitmentTerm = "Sin permanencia";

export const redirectToNovumBill =
  "https://appweb.movistar.es/_/account/redirect.php?target=account-invoices";

export const rent2rent = {
  devicesTypeR2R: 1,
  devicesTypeAdditionalR2R: 2,
};

export const r2rHiredTypes = {
  included: "incluido",
  additional: "adicional",
};

export const dataSharingTexts = {
  cardTitle: "Datos compartidos",
  itemListBottomText: "Móvil",
  donutText: "Datos",
  dataSharingStripTextStart: "Datos compartidos entre ",
  dataSharingStripTextEnd: "Consumidos",
};
export const expensesText = {
  tv: "Televisión",
  mobile: "Línea móvil",
  internet: "Internet",
  phone: "Línea Fija",
};

export const link2ChooseSmartphoneUrl =
  "https://www.movistar.es/particulares/fusion/elige-smartphone?pid=terminal-fusion-area-privada-tcol";
export const link2ChooseSmartphoneUrlPikolin =
  "https://www.movistar.es/particulares/mimovistar/elige-dispositivo?pid=terminal-fusion-area-privada-tcol";

export const TITLE_DAD_PIKOLIN = "miMovistar";

export const SPECIFIC_CUSTOMER_PRODUCT_OPTIONS = {
  SECURE_CONNECTION: "secureConnection",
  MOBILE_SECURE_CONNECTION: "mobileSecureConnection",
  CLOUD: "cloud",
  MOBILE_INSURANCE: "mobileInsurance",
  MOBILE_RENT2RENT: "mobileRent2Rent",
  FUSION_WITH_MOBILE_RENT2RENT: "fusionWithMobileRent2Rent",
  GAME_PASS: "gamePass",
  DEFAULT: "default",
};

export const SPECIFIC_CUSTOMER_PRODUCT_POSITIONS = {
  TOP: "top",
  BOTTOM: "bottom",
};

/* TOKENIZATION CATALOGUE */
export const BONO_DATOS = "datos";
export const BONO_TV = "tv";
export const BONO_MOVIL_DATOS_ILIMITADOS = "731";
export const BONO_MOVIL_DATOS_1GB7D = "769";
export const BONO_TV_1ALQUILER = "767";
export const BONO_TV_2ALQUILER = "768";
export const BONO_TV_ESTRENOS = "771";
export const BONO_TV_CLASICA = "772";
export const BONO_TV_LIGA = "773";
export const BONO_TV_CHAMPIONS = "774";
export const BONO_TV_DEPORTES = "775";
export const BONO_TV_MOVISTAR_SERIES = "1325";
export const BONO_TV_MEZZO = "1326";
export const BONO_TV_IBERALIA = "1327";
export const BONO_TV_CAZA_PESCA = "1328";
export const BONO_STATUS_YA_CONTRATADO = "0";
export const BONO_STATUS_NO_CONTRATADO = "1";
export const BONO_DETAIL_YA_CONTRATADO = "0";
export const BONO_DETAIL_DISPONIBLE_CONTRATACION = "1";
export const BONO_MOVIL_DETAIL_INCOMPATIBILIDAD_DATOS_COMPARTIDOS = "2";
export const BONO_MOVIL_DETAIL_IMCOMPATIBILIDAD_BONOS_DATOS = "3";
export const TITLE_HEAD_TOKENIZATION = "Usar tokens";

export const PO_IDS_SECURE_CONNECTION = [
  "411",
  "412",
  "413",
  "612",
  "410",
  "581",
];

export const SPECIFIC_CUSTOMER_PRODUCT_KINDS = {
  SECURE_CONNECTION: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.SECURE_CONNECTION,
    prodOfferList: ["412", "413", "612"],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.BOTTOM,
  },
  MOBILE_SECURE_CONNECTION: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.MOBILE_SECURE_CONNECTION,
    prodOfferList: ["410", "581"],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.TOP,
  },
  CLOUD: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.CLOUD,
    prodOfferList: ["434", "436", "501"],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.BOTTOM,
  },
  MOBILE_INSURANCE: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.MOBILE_INSURANCE,
    prodOfferList: ["12", "972", "973"],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.TOP,
  },
  MOBILE_RENT2RENT: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.MOBILE_RENT2RENT,
    prodOfferList: [],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.BOTTOM,
  },
  FUSION_WITH_MOBILE_RENT2RENT: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.FUSION_WITH_MOBILE_RENT2RENT,
    prodOfferList: [],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.BOTTOM,
  },
  GAME_PASS: {
    kind: SPECIFIC_CUSTOMER_PRODUCT_OPTIONS.GAME_PASS,
    prodOfferList: ["1280"],
    position: SPECIFIC_CUSTOMER_PRODUCT_POSITIONS.TOP,
  },
};

export const myDataText = {
  contactInfo: "Datos de contacto:",
  document: "Documento Fiscal:",
  contacto: "Datos de contacto:",
  cuenta: "Número de cuenta bancaria:",
  logout: "Cerrar sesión",
  name: "Nombre:",
  companyName: "Razón Social",
  email: "Email:",
  telefono: "Teléfono:",
  sms: "SMS:",
  direccionFacturacion: "Dirección de facturación:",
  recuperacionContraseña: "Recuperación de contraseña:",
  errorEmailNoValido: "Este email no es válido. Actualízalo, por favor.",
  errorEmailNoValidado:
    "Tu email está pendiente de validar. Puedes hacerlo solo con abrir el email que has recibido de Movistar.",
  notAddress: "No existe una dirección asociada",
  notFavouritePhone: "No quieres recibir llamadas",
  notFavouriteSMS: "No quieres recibir SMS",
};

export const clientInfoText = {
  dataModification: {
    header: "Mis datos",
    contractHolder: "Titular del contrato",
    companyName: "Razón Social",
    bankAccount: "Cuenta bancaria",
    contactEmail: "Email de contacto",
    notContactEmail: "No existe un email de contacto. Actualízalo.",
    phoneContact: {
      text: "Teléfono de contacto",
      notPhone: "No quieres recibir llamadas",
      notSMS: "No existe nº de teléfono. Actualízalo.",
    },
    billingAddress: {
      text: "Dirección de facturación",
      notAddress: "No existe una dirección asociada",
    },
    passwordRecovery: "Recuperación de contraseña",
    noUserYet: "Aún no tienes usuario. ¡Créalo ahora!",
  },
  claims: {
    noEmail: "Actualiza medio de contacto",
    noPhone: "Actualiza medio de contacto",
    activationPending: "Pendiente de activar",
    pending: "Pendiente",
  },
  movistarPlusDevices: {
    header: "Movistar Plus en dispositivos",
    myUser: "Mi usuario",
  },
};

export const loginText = {
  loginButton: "Entrar",
  loginDocument: "NIF/CIF/NIE/Pasaporte",
  loginPassword: "Contraseña",
  loginSubtitle:
    "Para continuar es necesario que te identifiques como titular.",
  loginTitle: "Accede como titular",
};

export const myDataLinks = [
  {
    id: 0,
    text: "Titular",
    link: "https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-21",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "cambio-titular",
    scope: "titular",
  },
  {
    id: 1,
    text: "Email de contacto",
    link: "https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-22",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "cambio-email",
    scope: "titular",
  },
  /*  {
    id: 2,
    text: 'Cuenta bancaria',
    link: 'https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-23',
    taggingType: taggingButtonTypes.LINK,
    taggingId: 'cambio-cuenta-bancaria',
    scope: 'titular',
  }, */
  {
    id: 3,
    text: "Idioma y guías",
    link: "https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-25",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "cambio-idioma",
    scope: "titular",
  },
  {
    id: 4,
    text: "Dirección postal",
    link: "https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-24",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "cambio-direccion-postal",
    scope: "titular",
  },
  /* {
    id: 5,
    text: 'Otros...',
    link: 'https://www.movistar.es/particulares/atencion-cliente/escribenos-simplificado/?tipo=telco&tipo_directo=15-26',
    taggingType: taggingButtonTypes.LINK,
    taggingId: 'cambio-otros',
    scope: 'titular',
  }, */
];

export const myNotedDataLinks = [
  {
    id: 0,
    text: '<span class="text1"> Por ser </span><span class="text2">PRIORITY</span>',
    link: "https://www.movistar.es/particulares/movistar-priority",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "por-ser-priority",
    className: "priority",
    scope: "priority",
    type: "Solid",
    theme: "Blue2",
  },
  {
    id: 1,
    text: "Privacidad",
    link: "/misDatos/consentimientos",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "privacidad",
    scope: "",
    type: "Soft",
    theme: "Blue",
    iconLibrary: iconLibrary.seguridad,
  },
  {
    id: 2,
    text: "Mis Pedidos",
    link: "/misDatos/seguimientoDePedido",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "seguimiento-pedidos-misdatos-destacados-mispedidos",
    iconLibrary: iconLibrary.shipping,
    scope: "",
    type: "Soft",
    theme: "Blue",
  },
  {
    id: 3,
    text: "Contratos y Permanencias",
    link: "/misContratos",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "contratosypermanencias",
    iconLibrary: iconLibrary.contratos,
    scope: "",
    type: "Soft",
    theme: "Blue",
  },
  {
    id: 4,
    text: "Modificar datos",
    link: "/misDatos/modificarMediosContacto",
    taggingType: taggingButtonTypes.LINK,
    taggingId: "modificarmedioscontacto",
    iconLibrary: iconLibrary.contratos,
    scope: "",
    type: "Soft",
    theme: "Blue",
  },
];

export const managementContest = {
  linea: "1",
  contacto: "2",
  fsp: "3",
  numeroMovil: "4",
  bannerMisDatos: "5",
  gestiones: "6",
};

// ESTADOS DE AUTODIAGNÓSTICO
export const EN_CURSO_AUTODIAGNOSTICO = "En curso";
export const FINALIZADO_AUTODIAGNOSTICO = "Finalizado";
export const EN_REVISION_AUTODIAGNOSTICO = "En revision";
export const CANCELADO_AUTODIAGNOSTICO = "Cancelado";
export const ANULADO_AUTODIAGNOSTICO = "Anulado";
export const ESPERA_CLIENTE_AUTODIAGNOSTICO = "En Espera de cliente";
export const PENDIENTE_CONFORMIDAD_AUTODIAGNOSTICO = "Pendiente de conformidad";

/* STATE AUTODIAGNOSTIC DETAIL */
export const EN_CURSO = 0;
export const FIN_CERRADO = 1;
export const FIN_PEND_ACT_TEL = 2;
export const FIN_PEND_ACT_USU = 3;
export const FIN_PEND_ASIG_TEC = 4;
export const FIN_PEND_ENV_LOG = 5;
export const FIN_PEND_TIEMPO = 6;

// ERRORES AUTODIAGNÓSTICO
export const ERROR_AFECTACION_MASIVA = "PRCL-WA-000734";
export const ERROR_CP_DUPLICADO = "PRCL-WA-000737";
export const NOT_ERROR = "sin errores";
export const PRODUCT_TEXTS = {
  productName: "1",
  productSummary: "2",
  productInfoTitle: "3",
  productPrice: "4",
  promotedPrice: "5",
};
export const TIMER_30_MINS = 30;
export const TIMER_5_MINS = 5;

export const extraExpensePeriod = "Gasto extra en ";
export const extraExpensePeriodTotal = "Gasto extra de esta línea:";
export const extraUsagesInterestingLinksMobile = [
  {
    title: "Puedes controlar tus gastos extra desde los siguiente enlaces.",
    links: [
      {
        name: "Restricción de números especiales",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 0,
        serviceId: "numeros",
        target: "_self",
        forceExternal: false,
      },
      {
        name: "Restricción de llamadas, datos y roaming",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 1,
        serviceId: "roaming",
        target: "_self",
        forceExternal: false,
      },
      {
        name: "Suscripciones de Emoción y Pagos online",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 2,
        serviceId: "emotion",
        target: "_self",
        forceExternal: false,
      },
      {
        name: "Otras gestiones",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 3,
        target: "_self",
        forceExternal: false,
      },
    ],
  },
];
export const extraUsagesInterestingLinksPhone = [
  {
    title: "Puedes controlar tus gastos extra desde los siguiente enlaces.",
    links: [
      {
        name: "Restricción de números especiales",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 0,
        target: "_self",
        forceExternal: false,
      },
      {
        name: "Restricción de llamadas, datos y roaming",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 1,
        target: "_self",
        forceExternal: false,
      },
      {
        name: "Otras gestiones",
        link: "https://atencionalcliente.movistar.es/?f=183",
        id: 3,
        target: "_self",
        forceExternal: false,
      },
    ],
  },
];
export const iconLabelExtraUsage = "Gestiones de línea";
export const USER_UPGRADE_CLEAR = "USER_UPGRADE_CLEAR";
export const BANNER_PREPAGO = false;

export const BONO_EXTRA_200MB = "bono-extra-200mb";
export const BONO_INTERNACIONAL_100MB = "bono-internacional-100";
export const BONO_HABLA_MAS = "bono-extra-habla";
export const BONO_NAVEGA_MAS = "bono-extra-1gb";
export const BONO_HABLA_LATINO = "bono-habla-latino";
export const BONO_HABLA_MUNDO = "bono-habla-mundo";

export const BONOS_PREPAGO_ID = {
  remanentes: {
    datos: "1647",
    voz: "1057",
  },
  franquicia: {
    prepago5: {
      datos: "1717",
      voz: "1017",
    },
    prepago7: {
      datos: "1718",
      voz: "1018",
    },
    prepago15: {
      datos: "1719",
      voz: "1019",
    },
  },
  voz: {
    hablaMas: "1020",
    internacional100: "1090",
    hablaLatino: "1091",
    hablaMundo: "1092",
    internacional: "1098",
    internacionalPrepago: {
      plus: "1097",
      premium: "1098",
      total: "1096",
    },
  },
  datos: {
    navegaMas: "1720",
    extra200mb: "1642",
    duplicacionGB: {
      prepago5: "1727",
      prepago7: "1728",
      prepago15: "1729",
    },
  },
  regalo: {
    premium: "1742", // Bono Regalo - Prepago Premium (140GB)
    total: "1743",   // Bono Regalo - Prepago Total (150GB)
  },
  fidelizacion: {
    plus: "1747",     // 10GB
    premium: "1748",  // 20GB
    total: "1749",    // 30GB
  },
  roaming: {
    plus: "1737",     // 7GB
    premium: "1738",  // 10GB
    total: "1739",    // 13GB
  },
};


export const contactEmptyStructure = {
  address: { id: null, locationFullAddress: null },
  advertisingUse: true,
  contactType: "EMAI",
  contactTypeTCOL: "4",
  favourite: true,
  value: "",
};

export const TEL_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
export const MOV_REGEX =
  /^\(?([6-7]{1})\)?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const CONTACT_TYPES = {
  TELF: {
    contactType: "TELF",
    contactTypeTCOL: "1",
  },
  SMS: {
    contactType: "SMS_",
    contactTypeTCOL: "2",
  },
  FAX: {
    contactType: "FAX",
    contactTypeTCOL: "3",
  },
  EMAI: {
    contactType: "EMAI",
    contactTypeTCOL: "4",
  },
  ADDRESS: {
    contactType: "DPOS",
    contactTypeTCOL: "5",
  },
};

/* CLIENT TYPE */
export const ONLY_CONTRACT = 1;
export const ONLY_PREPAID = 2;
export const CONTRACT_PREPAID = 3;

// APPID
export const AppIdMisProductos = "TCOLMP";
export const AppIdMisProductosWebview = "TCOLMPWB";
export const AppIdMovimientos = "TCOLMOV";
export const AppIdMovimientosWebview = "TCOLMOVWB";
export const AppIdRecargaFavorita = "TCOLFAV";

// Mis productos
export const RECARGA_CONTRA_TARJETA_IFRAME_MP = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/datosRecarga.html?appId=${AppIdMisProductos}&codOrigen=RCCLI`;
export const RECARGA_CONTRA_TARJETA_IFRAME_MP_OK_KO = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/recargaConfirm.html?appId=${AppIdMisProductos}&codOrigen=RCCLI`;

// Mis productos Webview
export const RECARGA_CONTRA_TARJETA_IFRAME_MPWB = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/datosRecarga.html?appId=${AppIdMisProductosWebview}&codOrigen=RCCLI`;
export const RECARGA_CONTRA_TARJETA_IFRAME_MPWB_OK_KO = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/recargaConfirm.html?appId=${AppIdMisProductosWebview}&codOrigen=RCCLI`;

// Movimientos
export const RECARGA_CONTRA_TARJETA_IFRAME_MOV = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/datosRecarga.html?appId=${AppIdMovimientos}&codOrigen=RCCLI`;
export const RECARGA_CONTRA_TARJETA_IFRAME_MOV_OK_KO = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/recargaConfirm.html?appId=${AppIdMovimientos}&codOrigen=RCCLI`;

// Movimientos Webview
export const RECARGA_CONTRA_TARJETA_IFRAME_MOVWB = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/datosRecarga.html?appId=${AppIdMovimientosWebview}&codOrigen=RCCLI`;
export const RECARGA_CONTRA_TARJETA_IFRAME_MOVWB_OK_KO = `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/publico/recargaConfirm.html?appId=${AppIdMovimientosWebview}&codOrigen=RCCLI`;

/* URL ClickToCall PREPAID */
export const BONO_EXTRA_200MB_C2C = "https://movistar.es/CC_C2C/navigate/";
export const BONO_INTERNACIONAL_100_C2C =
  "https://www.movistar.es/atcliente/c2c/servicio-online/index.jsp?language=es&service=bono-internacional-100";
export const BONO_HABLA_LATINO_C2C = "https://movistar.es/CC_C2C/latin-talk/";
export const BONO_HABLA_MUNDO_C2C = "https://movistar.es/CC_C2C/world-talk/";
export const BONO_HABLA_MAS_C2C = "https://movistar.es/CC_C2C/talk-plus/";
export const BONO_NAVEGA_MAS_C2C = "https://movistar.es/CC_C2C/navigate-plus/";
export const TARIFA_PREPAGO_5_C2C =
  "https://www.movistar.es/atcliente/c2c/tarifa-prepago/index.jsp?language=es&service=tarifa5";
export const TARIFA_PREPAGO_7_C2C =
  "https://www.movistar.es/atcliente/c2c/tarifa-prepago/index.jsp?language=es&service=tarifa7";
export const TARIFA_PREPAGO_15_C2C =
  "https://www.movistar.es/atcliente/c2c/tarifa-prepago/index.jsp?language=es&service=tarifa15";
export const TARIFA_PREPAGO_HABLA_6_C2C =
  "https://www.movistar.es/atcliente/c2c/tarifa-prepago/index.jsp?language=es&service=habla6";
export const ANTICIPO_SALDO_PUNTUAL_C2C =
  "https://movistar.es/CC_C2C/one-time-balance-advance/";
export const ANTICIPO_SALDO_AUTOMATICO_C2C =
  "https://movistar.es/CC_C2C/automatic-balance-advance/";
export const URL_C2C = "https://movistar.es/CC_C2C/";

export const modalContestDataLayer = {
  GAcategory: "Modal",
  GAaction: "Aparece",
  GAlabel: "TCOL-concurso-dinamizacion-gestiones-concurso-servicing-3q22",
  GAlabel2: "TCOL-dinamizacion-gasto-getionar-lineas",
};

export const modalContestButtonDataLayer = {
  GAcategory: "Interaccion",
  GAaction: "boton",
  GAaction2: "enlace",
  GAlabel: "gestion-realizada-acceso-concurso-3q22",
  GAlabel2: "",
};
export const FOA = {
  HUB: "hub",
};
/* PRODUCT TYPES CATEGORY */
export const CAT_FUSION = "1";
export const CAT_MODULAR = "2";
export const CAT_NETFLIX = "8";
export const CAT_DISNEY = "9";

export const webviewsName = {
  startTabNovum: "startTabNovum",
  transparencyCenter: "atc_download",
};

export const MOBILE_CONFIGURATION = {
  buzon: "buzon",
  desvio: "desvio",
};
export const USAGE_BAR_TYPE = {
  PPU_INDEX: -1,
  UNLIMITED: -2,
  EXTRA_PAYMENT: -3,
};

export const DATE_FORMATS = {
  SERVER: "YYYY-MM-DD",
  FRONT: "DD-MM-YYYY",
  US: "MM-DD-YYYY"
};

export const USAGE_PERIOD_IS_CLOSED = "Periodo cerrado";
export const USAGE_PERIOD = "Periodo de consumo";
export const USAGE_PERIOD_IS_CLOSED_INFO = "En periodos cerrados solo se muestran los consumos de productos vigentes a dia de hoy.";

export const CUSTOM_LINK_LABEL_DETAILE_USAGES = "Ver detalle de consumos";
export const CUSTOM_LINK_LABEL_DETAILED_USAGES = "Ver consumos";
export const EXTRA_USAGES_TEXTS = {
  EXTRA_USAGE: "Gasto extra",
  EXTRA_USAGE_PERIOD: "Gasto extra del periodo",
}
export const PREPAID_TARIFFS_NOT_RENEWED = "Se aplica la tarifa Habla 6 hasta que recargues el saldo suficiente para poder renovar tu tarifa habitual.";
export const PREPAID_TARIFFS_NOT_USAGES = `Para consultas sobre tu consumo, llama gratis al <a href="tel:2266">2266</a>.`;

export const CHANGE_MOBILE_RESTRICTION_ERROR_PEDIDO_VUELO =
  "TCOL-SERVICIOSTERCEROS-042";
export const TITLE_PEDIDO_VUELO = "Tu solicitud no ha podido ser enviada";
export const SUBTITLE_PEDIDO_VUELO =
  "Actualmente tienes otra tramitación en curso. Por favor, inténtalo de nuevo más tarde.";

export const USAGE_TEXT = {
  datos: "Datos",
  minutos: "Minutos",
  gb: "GB",
  kb: "KB",
  llamadas: "Llamadas",
  min: "min",
  tv: "TV",
  sms: "SMS",
  messages: "Mensajes",
  Roaming1: "Roaming fuera de zona 1",
  Roaming2: "Roaming en zona 1",
  titleUsageDetail: "Consumos realizados",
  moreInfo: "Más Info",
  sharedData: "Datos compartidos",
};

export const USAGE_TYPES = {
  datos: "data",
  voz: "voice",
  sms: "sms",
  otros: "others",
  info: "info",
};

export const SERVICE_FREE_INCLUDED = {
  title: "Servicios gratuitos incluidos",
};

export const MARK_LIST = {
  nuevoAP: "nAP",
};

export const SERVICE_TIPO_DESVIO = {
  N: "N",
};

export const posTV = [
  "37",
  "473",
  "483",
  "551",
  "948",
  "1767",
  "1772",
  "1773",
  "1775",
  "1776",
  "2991",
];

export const TYPE_EQUIPMENT_PRODUCT = 9;

export const includedFusion = "Incluido en tu contrato de Fusión.";
export const includedPikolin = "Incluido en tu contrato miMovistar.";
export const aditionalFusion = "Dispositivo adicional de Fusión.";
export const aditionalPikolin = "Dispositivo adicional miMovistar.";

export const ATTACHMENTS_TYPES_IMG_HIGH_RESOLUTION = "6";

export const CITA_PREVIA_TEXTS = {
  actualCita: "Cita actual",
  primeraCita: "Primera cita disponible",
  selectedNewDate: "Selecciona nueva fecha y hora. Las franjas horarias indican la llegada del técnico a tu domicilio.",
  mustSelectedDate: "Debes seleccionar una franja horaria",
  errorMessageFailModifyAppointment:
    "Ha ocurrido un error al modificar tu cita. Inténtalo de nuevo más tarde",
};

export const calendarLocaleES = {
  // months list by order
  months: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],

  // week days by order
  weekDays: [
    {
      name: "Lunes",
      short: "L",
    },
    {
      name: "Martes",
      short: "M",
    },
    {
      name: "Miércoles",
      short: "X",
    },
    {
      name: "Jueves",
      short: "J",
    },
    {
      name: "Viernes",
      short: "V",
    },
    {
      name: "Sábado",
      short: "S",
      isWeekend: true,
    },
    {
      name: "Domingo", // used for accessibility
      short: "D", // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 6,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  defaultPlaceholder: "Select...",

  // for input range value
  from: "from",
  to: "to",

  // used for input value when multi dates are selected
  digitSeparator: ",",

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

export const slots = [
  {
    index: 0,
    start: "09:00",
    startNormalized: "09:00",
    text: "09:00h - 11:00h",
  },
  {
    index: 1,
    start: "11:00",
    startNormalized: "11:00",
    text: "11:00h - 13:00h",
  },
  {
    index: 2,
    start: "13:00",
    startNormalized: "13:00",
    text: "13:00h - 15:00h",
  },
  {
    index: 3,
    start: "15:00",
    startNormalized: "15:00",
    text: "15:00h - 17:00h",
  },
  {
    index: 4,
    start: "17:00",
    startNormalized: "17:00",
    text: "17:00h - 19:00h",
  },
  {
    index: 5,
    start: "19:00",
    startNormalized: "19:00",
    text: "19:00h - 21:00h",
  },
];

export const slotsMobile = [
  {
    index: 0,
    start: "09:00",
    startNormalized: "09:00",
    text: "09:00h - 11:00h",
  },
  {
    index: 1,
    start: "15:00",
    startNormalized: "15:00",
    text: "15:00h - 17:00h",
  },
  {
    index: 2,
    start: "11:00",
    startNormalized: "11:00",
    text: "11:00h - 13:00h",
  },
  {
    index: 3,
    start: "17:00",
    startNormalized: "17:00",
    text: "17:00h - 19:00h",
  },
  {
    index: 4,
    start: "13:00",
    startNormalized: "13:00",
    text: "13:00h - 15:00h",
  },
  {
    index: 5,
    start: "19:00",
    startNormalized: "19:00",
    text: "19:00h - 21:00h",
  },
];

export const ID_ACTIVACION = "7";
export const CONECTED = "Conectada";
export const DISCONECTED = "Desconectada";

export const idPosOcultarCuotaR2RIncluido = [
  "2829",
  "2830",
  "2831",
  "2832",
  "2833",
  "2834",
  "2835",
  "2837",
  "2838",
  "2839",
  "2840",
  "2841",
  "2833",
  "2835",
  "3424",
  "3425",
  "3427",
  "3426",
  "3307",
  "3308",
  "3309",
  "3310",
  "3311",
  "3428",
  "3429",
  "3430",
  "3431",
  "3432",
  "3433",
];

export const STATUS_TYPES = {
  FUSION: "fusion",
  ADDON: "addOn",
  CONTRACT: "contract",
  ACTIVATED: "activated",
};

export const AP_ACTIVACION_HBO_ALIAS = [
  "000_AP_MODULO_IMAGEN",
  "001_AP_MODULO_SIN_ACTIVAR",
  "002_AP_MODULO_ACTIVADO",
  "003_AP_MODULO_NO_CONTRATADO",
  "004_AP_MODULO_PREGUNTAS_FRECUENTES",
];

export const poIdsFttrPrincipal = "2943";
export const poIdsFttrAdicional = "2944";
export const poIdsFttrPrincipalPagoUnico = "4832";
export const poIdsFttrAdicionalPagoUnico = "4839";
export const poIdsFttrAdicionalExtraPagoUnico = "4840";
export const poIdsFttrPrincipalRenting = "4837";
export const poIdsFttrAdicionalRenting = "4838";
export const poIdsFttrAdicionalExtraRenting = "4841";

export const poIdsFttr = [
  poIdsFttrPrincipal,
  poIdsFttrAdicional,
  poIdsFttrPrincipalPagoUnico,
  poIdsFttrAdicionalPagoUnico,
  poIdsFttrAdicionalExtraPagoUnico,
  poIdsFttrPrincipalRenting,
  poIdsFttrAdicionalRenting,
  poIdsFttrAdicionalExtraRenting,
];

export const LINK_FTTR =
  "/area-cliente/mis-productos/fttr";
export const TITLE_FTTR = "Añadido a tu fibra";
export const SUB_TITLE_FTTR = "Solución FTTR Movistar";
export const DESCRIPTION_FTTR = "";
export const VIEW_DETAIL = "Ver detalle";
export const LABEL_MY_PACK = "Ver pack completo";
export const LINK_TO_MY_PACK = "/area-cliente/mis-productos/mi-pack";
export const LINK_TO_MOBILE_DETAIL = "/area-cliente/mis-productos/linea-movil";
export const LINK_TO_INTERNET_DETAIL = "/area-cliente/mis-productos/internet/detalle";
export const LINK_TO_TV_DETAIL = "/area-cliente/mis-productos/tv/detalle";
export const PATH_PRIVATE_AREA = {
  misProductos: "/area-cliente/mis-productos",
  facturas: "/area-cliente/facturas",
  perfil: "/area-cliente/mi-perfil",
  consumos: "/area-cliente/mis-productos/consumos",
  gestiones: "/area-cliente/gestiones",
  detalleProducto: "/area-cliente/mis-productos/*",
};

export const PRIVATE_AREA_TYPES = {
  misProductos: "mis-productos",
  facturas: "facturas",
  perfil: "mi-perfil",
  consumos: "consumos",
  gestiones: "gestiones",
  detalleMovil: "linea-movil",
  detalleInternet: "internet",
  detalleFijo: "linea-fija",
  detalleCar: "car",
  detalleSalud: "salud",
  detalleGaming: "gaming",
  soporte: "soporte",
  consents: "consents"
};

export const DEVICE_TITLE = "DISPOSITIVO";
export const INCLUDE_DEVICE_TITLE = "DISPOSITIVO INCLUIDO";
export const PRODUCT_TYPE_FUSION_MI_MOVISTAR = 0;

export const PACK_KEYS = {
  internet: 1,
  ilimitado: 1,
  max: 1,
  móvil: 2,
  televisión: 3,
  dispositivos: 4,
};

export const CITA_PREVIA_OPERATION_TYPES = {
  MODIFY: 'modificar',
  CREATE: 'crear',
}

export const MIN_VALUE_HISTOGRAM_BAR = 10;
export const MIN_NUM_HISTOGRAM_BARS = 9;

export const CLAIMED_BILL_ACTIVE = "En curso";
export const CLAIMED_BILL_FINISH = "Finalizada";
export const LABEL_CLAIMED_BILL_ACTIVE = "Fact. reclamada en curso";
export const LABEL_CLAIMED_BILL_FINISH = "Fact. reclamada finalizada";
export const MOVISTAR_CLOUD = "436";
export const XBOX_GAME_PASS = "23";
export const SEGURO_MOVIL_PRODUCT_OFFERING_TYPE = "34";
export const MOVISTAR_CAR_PRODUCT_OFFERING_TYPE = "111";
export const MOVISTAR_CAR_POIDS = ["541", "1420"];
export const EQUIPAMIENTO_PRODUCT_OFFERING_TYPE = ["24", "101"];
export const SEGURO_MOVIL_POIDS = ["12", "972", "973", "3409", "3410"];
export const FICCION_TOTAL_DISNEY_ANTIGUO_POID = "3371";
export const FICCION_DISNEY_NETFLIX_ANTIGUO_POID = "3078";
export const DISNEY_ESTANDAR_ANTIGUO_POID = "3370";

export const BILL_STATE_PAID = "PAGADA";
export const BILL_STATE_UNPAID = "IMPAGADA";
export const BILL_STATE_PARTIALLY_UNPAID = "PARCIALMENTE_PAGADA";
export const PAYMENT_STATE_AVAILABLE = "DISPONIBLE";
export const PAYMENT_STATE_ND = "ND";

export const BILL_LABEL_STATE_CLAIM = "Reclamada";
export const BILL_LABEL_STATE_AVAILABLE = "Disponible";
export const BILL_LABEL_STATE_PAID = "Pagada";
export const BILL_LABEL_STATE_PAID_TO_CLIENT = "Abonada";
export const BILL_LABEL_STATE_UNPAID = "Pendiente de pago";

export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_100_DESKTOP = 180;
export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_50_DESKTOP = 75;
export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_100_TABLET = 190;
export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_50_TABLET = 75;
export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_100_MOBILE = 45;
export const MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WIDTH_50_MOBILE = 18;
export const ADDITION_TO_MAX_LENGTH_PRODUCT_CARD_SUBTITLE_WHEN_NO_COUNTER = 14;

export const MOBILE_TYPE = "MOBILE";
export const MI_MOVISTAR_WITH_NETFLIX = "2438";
export const NETFLIX_BUNDLE_ID = "498";

export const SESION_ESIM_PENDING_ID = "sesionEsimPendingId";
export const SESION_ESIM_RESOURCES_IDS = "sesionEsimResources";
export const ESIM_STATUS_PENDING = "en-curso";

export const ESIM_URLS = {
  ContainerLineSelection: { id: 0, nameUrl: "Line" },
  ContainerDeviceSelection: { id: 1, nameUrl: "Device" },
  ContainerQRSelection: { id: 2, nameUrl: "QR" },
  ContainerCodeSelection: { id: 3, nameUrl: "Code" },
  ContainerMultisimSelection: { id: 6, nameUrl: "Multisim" },
  ContainerReinstallationSelection: { id: 7, nameUrl: "Reinstallation" },
  ContainerRedirectSelection: { id: 8, nameUrl: "Redirect" },
  ContainerMultisimLineSelection: { id: 9, nameUrl: "MultisimLine" },
  ContainerQRDesktopSelection: { id: 10, nameUrl: "QRDesktop" },
  ContainerWarning: { id: 11, nameUrl: "Warning" },
  ContainerIphoneUniversalSelection: { id: 12, nameUrl: "IphoneUniversal" },
  ContainerICCSelection: { id: 13, nameUrl: "ICC" },
  ContainerAndroidUniversalSelection: { id: 14, nameUrl: "AndroidUniversal" },
  ContainerCIFICCSelection: { id: 15, nameUrl: "ICCwithCIF" },
};
export const ESIM_SIM_TO_ESIM_PAGES = [0, 11, 13];
export const ESIM_INSTALL_PAGES = [0, 1, 2, 3, 10, 11, 12, 14];
export const ESIM_REINSTALL_PAGES = [0, 1, 2, 3, 7, 10, 11, 12, 14];
export const ESIM_INSTALL_MULTISIM_PAGES = [0, 1, 2, 3, 7, 9, 10, 11, 12, 14];

export const getEsimContainerInfo = (containerName) => {
  return ESIM_URLS[containerName] || null;
};

export const getEsimIdByName = (nameUrl) => {
  const entry = Object.entries(ESIM_URLS).find(
    ([_, value]) => value.nameUrl === nameUrl
  );
  return entry ? entry[1].id : null;
};

export const getEsimContainerById = (id) => {
  const entry = Object.entries(ESIM_URLS).find(([_, value]) => value.id === id);
  return entry ? entry[1].nameUrl : null;
};

export const TYPE_N2 = "N2";
export const TYPE_N3 = "N3";

export const PHONE_SERVICEID_TO_POID = {
  [CALL_RESPONSE_LANDLINE]: ["93"],
  [CALL_RESPONSE_LANDLINE_RADIO]: ["1195"],
  [IDENTITI_CALL_LANDLINE]: ["32", "628"],
  [IDENTITI_CALL_LANDLINE_RADIO]: ["1081"],
  [WAITING_LANDLINE]: ["47"],
  [WAITING_LANDLINE_RADIO]: ["1084"],
  [INMEDIATE_DETOUR_LANDLINE]: ["61"],
  [INMEDIATE_DETOUR_LANDLINE_RADIO]: ["1085"],
  [COMUNICATE_DETOUR_LANDLINE]: ["529"],
  [COMUNICATE_DETOUR_LANDLINE_RADIO]: ["1086"],
  [NOT_RESPONSE_DETOUR_LANDLINE]: ["530"],
  [NOT_RESPONSE_DETOUR_LANDLINE_RADIO]: ["1087"],
  [DIVERSION_DO_NOT_DISTURB]: ["531"],
  [BASIC_PACK_LANDLINE]: ["105", "1399"],
  [MULTI_CALL_LANDLINE]: ["42"],
  [MULTI_CALL_LANDLINE_RADIO]: ["1083"],
  [CALL_REJECTION_LANDLINE]: ["52"],
  [LOST_CALL_LANDLINE]: ["62"],
  [TERMINAL_PACK]: ["68", "1400"],
};

export const PHONE_CONFIG_LITERALS = {
  [CALL_RESPONSE_LANDLINE]: { title:"Tienes contratado el servicio Contestador Automático" },
  [CALL_RESPONSE_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Contestador  Automático Radio" },
  [IDENTITI_CALL_LANDLINE]: { title:"Tienes contratado el servicio Identificación de Llamadas" },
  [IDENTITI_CALL_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Identificación de Llamadas Radio" },
  [WAITING_LANDLINE]: { title:"Tienes contratado el servicio Llamada en Espera" },
  [WAITING_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Llamada en Espera Radio" },
  [INMEDIATE_DETOUR_LANDLINE]: { title:"Tienes contratado el servicio Desvío Inmediato" },
  [INMEDIATE_DETOUR_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Desvío Inmediato radio" },
  [COMUNICATE_DETOUR_LANDLINE]: { title:"Tienes contratado el servicio Desvío si comunica" },
  [COMUNICATE_DETOUR_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Desvío si comunica radio" },
  [NOT_RESPONSE_DETOUR_LANDLINE]: { title:"Tienes contratado el servicio Desvío si no contesta" },
  [NOT_RESPONSE_DETOUR_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Desvío si no contesta Radio" },
  [DIVERSION_DO_NOT_DISTURB]: { title:"Tienes contratado el servicio Desvío No Molesten" },
  [BASIC_PACK_LANDLINE]: { title:"Tienes contratado el servicio Pack de Servicios Básicos" },
  [MULTI_CALL_LANDLINE]: { title:"Tienes contratado el servicio Llamada a Tres" },
  [MULTI_CALL_LANDLINE_RADIO]: { title:"Tienes contratado el servicio Llamada a Tres radio" },
  [CALL_REJECTION_LANDLINE]: { title:"Tienes contratado el servicio Rechazo Selectivo de Llamadas" },
  [LOST_CALL_LANDLINE]: { title:"Tienes contratado el servicio Llamada sin Marcar" },
  [TERMINAL_PACK]: { title:"Tienes contratado el servicio Pack Terminal (Mantenimiento y Servicios)" },
};

export const RECHARGE_PREPAID_BTN_LABEL = "Recargar saldo";
